module.exports = __webpack_public_path__ + "static/media/completed-nuggets.d5b11a84.svg";